export const NOTIFICATION_SET = 'NOTIFICATION_SET';
export const NOTIFICATION_UNSET = 'NOTIFICATION_UNSET';
